import { render, staticRenderFns } from "./Step2ConnectToInstagram.vue?vue&type=template&id=0ef1b11c&"
import script from "./Step2ConnectToInstagram.vue?vue&type=script&lang=js&"
export * from "./Step2ConnectToInstagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Step2ConnectToInstagram.vue"
export default component.exports